import React from 'react';
import * as classes from './CopyBox.module.scss';

type CopyBoxProps = {
  text: string;
};

export default function CopyBox({ text }: CopyBoxProps) {
  return <div className={classes.CopyBox} dangerouslySetInnerHTML={{ __html: text }}></div>;
}
